<template>
    <div class="traitContainer">
        <div class="traitItem" >
          <!-- <button @click="add">add</button>  -->
          <b-icon-plus-circle class="addButton" @click="add"></b-icon-plus-circle>
        </div>
        <div class="traitItem" >
          <h4 class="header">{{ source.name }}</h4>
          <p>{{ source.description }}</p>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'add-trait-component',
    props: {
      tabIndex: Number,
      index: { // index of current item
        type: Number
      },
      source: { // here is: {uid: 'unique_1', text: 'abc'}
        type: Object,
        default () {
          return {}
        }
      },
    },  
    methods:{
      add(){
        switch(this.tabIndex){
          case 1:
            this.dispatch('App', 'traitAdded', this.source.uid, this.index);
            break;
          case 2:
            this.dispatch('App', 'actionAdded', this.source.uid, this.index)
            break;
          case 3:
            this.dispatch('App', 'legendActionAdded', this.source.uid, this.index)
            break;
          default:
            console.error("tabIndex out of bounds");
        }
      },
      dispatch (componentName, eventName, ...rest) {
        let parent = this.$parent || this.$root
        let name = parent.$options.name
        while (parent && (!name || name !== componentName)) {
            parent = parent.$parent
            if (parent) {
              name = parent.$options.name
            }
        }
        if (parent) {
            parent.$emit.apply(parent, [eventName].concat(rest))
        }
      }
    }
  }
</script>

<style>

 .property-line{
    /* line-height: 1.4; */
    /* display: inline; */
    /* float:left; */
    display: block;
    text-indent: -1em;
    padding-left: 1em;
  }

  h4.header{
     /* line-height: 1.4; */
    
    /* margin: 0; */
    /* display: inline; */
    /* display: table; */
    font-weight: bold;
    padding-right: 0.3em;
  }

  h4.header, p{
    /* vertical-align: top; */
    margin: 0;
    display: inline;  
  }

  p{
    text-indent: 1em;
  }

  p:first-of-type{
    /* display: inline;   */
    text-indent: 0;
  }  

  .line:hover{
    background-color: white;
  }
  .line:focus{
    background-color: white;
  }

  .traitContainer{
    display: flex;
  }
  .traitItem{
    padding: 5px;
    /* padding-left: 40px; */
    display: inline-block;
    vertical-align: top;
    margin:auto;
    text-align: left;
  }

  .addButton{
    cursor:pointer;
  }
</style>